import { Typography, Button } from "antd";
import {
  ArrowRightOutlined,
  MailOutlined,
  TeamOutlined,
} from "@ant-design/icons";
import {
  containerLight,
  title,
  sizePrimaryBtn,
  smallContainer,
} from "../styles";
import { motion } from "framer-motion";
import chatRivo from "../files/chatrivo.png";
const { Title, Text } = Typography;

const animationY = -100;
const animationDuration = 0.4;

const container = {
  hidden: {},
  show: {
    transition: {
      staggerChildren: 0.12, // her eleman arası
      delayChildren: 0.2, // ilk eleman gecikmesi
    },
  },
};

const item = {
  hidden: { opacity: 0, y: -30 },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.9,
      ease: "easeOut",
    },
  },
};

function GlassContainer(args) {
  const lightness = args.lightness ? args.lightness : 100;
  const saturation = args.saturation ? args.saturation : 100;
  const hue = args.hue ? args.hue : 255;

  const cont = (
    <div
      className={args.hoverAnimation && "hoverable-container"}
      style={{
        background:
          !args.noBg &&
          `hsla(${hue}, ${saturation}%, ${lightness}%,${
            args.opacity ? args.opacity : 0.12
          })`,
        WebkitBackdropFilter: !args.noBg && "blur(50px)",
        backdropFilter: !args.noBg && "blur(14px)",
        width:
          args.device === "pc"
            ? args.width
            : args.small_width
            ? args.small_width
            : args.width,
        minHeight: args.device === "phone" ? args.height : args.bigger_height,
        border: !args.noBg && "1px solid rgba(255, 255, 255, 0.25)",
        boxShadow: !args.noBg && "0 8px 32px rgba(0, 0, 0, 0.25)",
        borderRadius: "10px",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        flexGrow: args.flexGrow,
        marginBottom: "1rem",
        
      }}
    >
      {args.inside}
    </div>
  );

  return args.hoverAnimation ? (
    cont
  ) : (
    <motion.div
      variants={container}
      initial={{ opacity: 0, y: animationY }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: animationDuration, ease: "easeOut" }}
      onTransitionEnd={(e) => {
        e.preventDefault();
      }}
    >
      {cont}
    </motion.div>
  );
}

function Welcomer(args) {
  return (
    <motion.div
      variants={container}
      initial={{ opacity: 0, y: animationY }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: animationDuration, ease: "easeOut" }}
      className="container"
      style={containerLight(args.device, args.noBg)}
    >
      {/*<div className="decoration" style={{width:"32vw",height:"28vw", backgroundColor:"var(--lightbg)",position:"absolute",right:"1rem",top:"7rem"}}></div>*/}

      <div
        style={{
          display: "flex",
          alignItems: args.device === "phone" ? "center" : "flex-start",
          flexDirection: "column",
          textAlign: args.device === "phone" ? "center" : "start",
        }}
      >
        <Title className="title" style={title(args.device)}>
          <div>Paranı Değil,</div>
          <div>Seni Düşünen Uygulamalar.</div>
        </Title>
        <Text
          style={{
            color: "var(--light)",
            fontSize: args.device === "pc" ? "3rem" : "1rem",
          }}
        >
          Senin olan uygulamanı dilediğin gibi kişiselleştir ve önerilerini
          bizimle paylaş
        </Text>
      </div>
      <motion.div
        variants={item}
        className="buttons"
        style={{
          display: "flex",
          flexWrap: "wrap",
          minWidth: args.device === "pc" && "80vw",
          justifyContent: args.device === "phone" && "center",
          gap: "1rem",
          "--delay": "0.5s",
        }}
      >
        <Button
          size="large"
          style={sizePrimaryBtn}
          href="/projects"
          type="primary"
        >
          Projeleri gör
          <ArrowRightOutlined />
        </Button>
        <Button size="large" href="/forum" style={sizePrimaryBtn}>
          Forum
          <TeamOutlined />
        </Button>
        <Button size="large" href="/contact" style={sizePrimaryBtn}>
          Bize ulaş
          <MailOutlined />
        </Button>
      </motion.div>
    </motion.div>
  );
}

function Whoarewe(args) {
  return (
    <motion.div
      variants={container}
      initial={{ opacity: 0, y: animationY }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: animationDuration, ease: "easeOut" }}
      className="container"
      style={smallContainer(args.device, args.noBg, 30)}
    >
      <div
        style={{
          display: "flex",
          alignItems: args.device === "phone" ? "center" : "flex-start",
          flexDirection: "column",
          textAlign: args.device === "phone" ? "center" : "start",
        }}
      >
        <Title className="title" style={title(args.device)}>
          <div>Biz kimiz?</div>
        </Title>
        <Text
          style={{
            color: "var(--light)",
            fontSize: args.device === "pc" ? "2rem" : "1rem",
          }}
        >
          Zenofy, işletmelere modern ve kullanımı kolay yazılım çözümleri sunan
          bir yazılım şirketidir. Amacımız, süreçleri basitleştiren, verimliliği
          artıran ve kullanıcı deneyimini ön planda tutan dijital ürünler
          geliştirmektir. Yenilikçi yaklaşımımız ve güçlü teknik altyapımızla,
          iş ortaklarımızın yazılım ihtiyaçlarının karşılanmasında güvenilir bir
          çözüm ortağı olmayı hedefliyoruz.
        </Text>
      </div>
    </motion.div>
  );
}
function Mission(args) {
  return (
    <motion.div
      variants={container}
      initial={{ opacity: 0, y: animationY }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: animationDuration, ease: "easeOut" }}
      className="container"
      style={smallContainer(args.device, args.noBg, 30)}
    >
      <div
        style={{
          display: "flex",
          alignItems: args.device === "phone" ? "center" : "flex-start",
          flexDirection: "column",
          textAlign: args.device === "phone" ? "center" : "start",
        }}
      >
        <Title className="title" style={title(args.device)}>
          <div>Misyonumuz</div>
        </Title>
        <Text
          style={{
            color: "var(--light)",
            fontSize: args.device === "pc" ? "2rem" : "1rem",
          }}
        >
          Misyonumuz, kullanıcılarımıza kullanımı basit ve rahat aynı zamanda
          işlevli uygulamalar sunmaktır. Kullanıcılarımızın; günlük hayatta
          çevrimiçi etkileşimlerini daha verimli kılan, internet üzerinde
          düzenli yaptıklarını bir eziyet olmaktan çıkarıp kolaylaştıran, her
          gün kullanabilecek kadar basit ama kullanırken pişman etmeyecek kadar
          kaliteli uygulamalarla günlük hayatta teknolojiyi daha verimli
          kullanmalarını sağlamak amacımızdır.
        </Text>
      </div>
    </motion.div>
  );
}

function Vision(args) {
  return (
    <motion.div
      variants={container}
      initial={{ opacity: 0, y: animationY }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: animationDuration, ease: "easeOut" }}
      className="container"
      style={smallContainer(args.device, args.noBg, 30)}
    >
      <div
        style={{
          display: "flex",
          alignItems: args.device === "phone" ? "center" : "flex-start",
          flexDirection: "column",
          textAlign: args.device === "phone" ? "center" : "start",
        }}
      >
        <Title className="title" style={title(args.device)}>
          <div>Vizyonumuz</div>
        </Title>
        <Text
          style={{
            color: "var(--light)",
            fontSize: args.device === "pc" ? "2rem" : "1rem",
          }}
        >
          Vizyonumuz; verimli, basit ama bir o kadar da kaliteli, teknoloji ile
          beraber gelişen ve kullanıcı dostu uygulamalar üretmektir. Kısaca uzun
          süreçleri kısaltıp hızlı ve bir o kadar da kaliteli sonuçlar üreten,
          son kullanıcıya destek olan ve değişmekte olan dünya ile gelişen
          teknolojilere uyum sağlayan uygulamalar sunmak şirketimizin yegane
          amacıdır.
        </Text>
      </div>
    </motion.div>
  );
}

function EventLoop(args) {
  return (
    <div
      style={{
        display: "flex",
        overflow: "scroll",
        flexDirection: "row",
        gap: "1rem",
        paddingBottom: "1rem",
      }}
    >
      <div className="event">
        <img alt="" src={chatRivo} />
        <div>
          <Title
            className="title"
            level={1}
            style={{ color: "var(--darkoth)" }}
          >
            {" "}
            ChatRivo'nun Çıkışı!
          </Title>

          <Button type="link">Devamını oku...</Button>
        </div>
      </div>

      <div className="event">
        <img alt="" src="" />
        <div>
          <Title
            className="title"
            level={1}
            style={{ color: "var(--darkoth)" }}
          >
            {" "}
            ChatRivo'nun Çıkışı!
          </Title>

          <Button type="link">Devamını oku...</Button>
        </div>
      </div>
    </div>
  );
}

function Events(args) {
  return (
    <motion.div
      variants={container}
      initial={{ opacity: 0, y: animationY }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      transition={{ duration: animationDuration, ease: "easeOut" }}
      className="container"
      style={smallContainer(args.device, args.noBg)}
    >
      <div
        style={{
          display: "flex",
          alignItems: args.device === "phone" ? "center" : "flex-start",
          alignSelf: "flex-start",
          flexDirection: "row",
          textAlign: args.device === "phone" ? "center" : "start",
        }}
      >
        <Title className="title" style={title(args.device)}>
          <span>Yaklaşan Etkinlikler</span>
        </Title>
      </div>
      <div
        className="eventLoop"
        style={{
          display: "flex",
          flexWrap: "wrap",
          width: args.device === "pc" && "80vw",
          minHeight: "50rem",
          overflow: "scroll",
          justifyContent: args.device === "phone" && "center",
          gap: "1rem",
        }}
      >
        <EventLoop device={args.device} />
      </div>
    </motion.div>
  );
}

export { GlassContainer, Welcomer, Whoarewe, Mission, Vision, Events };
